<template>
  <v-container fluid class="currency-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-currency`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Currency
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-lists`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Lists
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-rates`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Rates
          </v-tab>
          <v-tab-item
            :value="'tab-currency'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="left">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Currency</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeCurrency($event, 'currencycode')"
                        v-bind:value="initvalue.currencycode"
                        placeholder="Currency Code"
                        persistent-hint
                        single-line hint="Enter the currency code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeCurrency($event, 'currencyname')"
                        v-bind:value="initvalue.currencyname"
                        placeholder="Currency Name"
                        persistent-hint
                        single-line hint="Enter the currency name">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=currencytype
                        :value="initvalue.currencytype"
                        outlined
                        dense
                        v-on:change="onChangeCurrency($event, 'currencytype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the currency type">
                      </v-select>
                      <v-row no-gutters style="margin-top: -20px;">
                        <v-col md="6">
                          <v-switch
                            color="primary"
                            v-on:change="onChangeCurrency($event, 'isPrimary')"
                            v-bind:label="initvalue.isPrimary"
                            v-model="initvalue.isPrimary"
                            hint="Primary Currency"
                            :false-value="false"
                            persistent-hint
                          ></v-switch>
                        </v-col>
                        <v-col md="6">
                          <v-switch
                            color="primary"
                            v-on:change="onChangeCurrency($event, 'currencystatus')"
                            v-bind:label="initvalue.currencystatus"
                            v-model="initvalue.currencystatus"
                            value="Active"
                          ></v-switch>    
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md=12>
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/currency/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="editCurrencyRequest()">
                          Save
                        </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-lists'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Currency List</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddList = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-2"
                          color="primary"
                          to="/currency/list"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="currencyrank"
                        :headers="header_lists"
                        :items="currencylists"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteList" width="500">
                            <v-card>
                              <v-card-title> Delete this List? </v-card-title>
                              <v-card-text>
                                {{ delete_list.currencycode }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteList = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteCurrencyList(delete_list)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editCurrencyListDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteCurrencyListDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-rates'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Currency Rates</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddItem = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/currency/list"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="currencydate"
                        sort-desc
                        :headers="header_rates"
                        :items="currencyrates"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteItem" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_item.itemname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteItem = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteCurrencyItem(delete_item)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.currencyrate="{ item }">
                          {{ item.currencyrate.toFixed(2) }}
                        </template>                 
                        <template v-slot:item.currencydate="{ item }">
                          {{
                            new Date(item.currencydate).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editCurrencyItemDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteCurrencyItemDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddList"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add List</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>

            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_list.currencyrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_list.currencycode"
                  label="Code"
                  single-line
                  hint="Code"
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  type="Number"
                  v-model="add_list.currencyfactor"
                  label="Factor"
                  single-line
                  hint="Factor"
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                type="Number"
                  v-model="add_list.currencyrounding"
                  label="Rounding"
                  single-line
                  hint="Rounding"
                  dense
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddList=false; add_list={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addCurrencyListRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddSubgroup"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Subgroup</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>

            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_subgroup.subcurrencyrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <!-- <v-col cols="12" md="10">
                <v-select
                  class="mb-4"
                  :items="currencylists.map(x => {
                    return {text: x.currencycode, value: x._id};
                  })"
                  v-model="add_subgroup.groupid"
                  v-bind:error="errorindex == 3"
                  placeholder="List"
                  dense
                >
                </v-select>
              </v-col> -->
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_subgroup.subgroupname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_subgroup.subcurrencycode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_subgroup.subcurrencyfactor"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddSubgroup=false; add_subgroup={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addCurrencyItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_item.itemrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <!-- <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="currencylists.map(x => {
                    return {text: x.currencycode, value: x._id};
                  })"
                  v-model="add_item.groupid"
                  v-bind:error="errorindex == 3"
                  placeholder="List"
                  dense
                >
                </v-select>
              </v-col> -->
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_item.itemname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_item.itemcode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_item.itemicon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_item.itemlink"
                  label="Link"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_item.itemaction"
                  label="Action"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddItem=false; add_item={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addCurrencyItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditList"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit List</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeList($event, 'currencyrank')"
                  :value="edit_list.currencyrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeList($event, 'currencycode')"
                  :value="edit_list.currencycode"
                  label="Code"
                  required
                  hint="Code"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="onChangeList($event, 'currencyfactor')"
                  :value="edit_list.currencyfactor"
                  label="Factor"
                  required
                  hint="Factor"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="onChangeList($event, 'currencyrounding')"
                  :value="edit_list.currencyrounding"
                  label="Rounding"
                  required
                  hint="Rounding"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditList = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editCurrencyListRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemrank')"
                  :value="edit_item.itemrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <!-- <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="currencylists.map(x => {return {text: x.currencycode, value: x._id};})"
                  v-on:change="onChangeItem($event, 'currencycode')"
                  :value="edit_item.groupid"
                  placeholder="List"
                  hint="Code"
                  dense
                >
                </v-select>
              </v-col> -->
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemname')"
                  :value="edit_item.itemname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemcode')"
                  :value="edit_item.itemcode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemicon')"
                  :value="edit_item.itemicon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemlink')"
                  :value="edit_item.itemlink"
                  label="Link"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemaction')"
                  :value="edit_item.itemaction"
                  label="Action"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditItem=false; edit_item={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editCurrencyItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      header_lists: [
        { text: "#", value: "currencyrank", width: "10px" },
        { text: "Code", value: "currencycode" },
        { text: "Factor", value: "currencyfactor" },
        { text: "Rounding", value: "currencyrounding" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_rates: [
        { text: "Date", value: "currencydate", width: "10%" },
        { text: "Base", value: "currencybase", width: "10%"  },
        { text: "Cross ", value: "currencycross", width: "10%"  },
        { text: "Rate ", value: "currencyrate", width: "10%"  },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      currency: {},
      currencylists: [],
      currencyrates: [],
      currencytype: ['Currency', 'Other Currency'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      add_list: {},
      add_subgroup: {},
      add_item: {},
      add_channel: {},
      edit_list: {},
      edit_subgroup: {},
      edit_item: {},
      edit_channel: {},
      change_currency: {},
      change_list: {},
      change_subgroup: {},
      change_item: {},
      change_channel: {},
      delete_list: {},
      delete_subgroup: {},
      delete_item: {},
      delete_channel: {},
      isDeleteList: false,
      isDeleteSubgroup: false,
      isDeleteItem: false,
      isDeleteChannel: false,
      isAddList: false,
      isAddSubgroup: false,
      isAddItem: false,
      isAddChannel: false,
      isEditList: false,
      isEditSubgroup: false,
      isEditItem: false,
      isEditChannel: false,
    }
  },
  computed: {
    ...mapState('Currency', ['isReceiving'])
  },
  methods: {
    ...mapActions('Currency', 
    [ 'getCurrenciesRequest',
      'deleteCurrencyListRequest', 'deleteCurrencySubgroupRequest', 'deleteCurrencyItemRequest',
      'insertCurrencyListRequest', 'insertCurrencySubgroupRequest', 'insertCurrencyItemRequest',
      'updateCurrencyRequest','updateCurrencyListRequest','updateCurrencySubgroupRequest','updateCurrencyItemRequest' 
    ]),
    async addCurrencyListRequest() {
      this.isAddList = false;
      this.add_list.currencyid = this.initvalue._id;
      let result = await this.insertCurrencyListRequest(this.add_list);
      this.currencylists.push(result);
      this.add_list = {};
    },
    async addCurrencyItemRequest() {
      this.isAddItem = false;
      this.add_item.currencyid = this.initvalue._id;
      let result = await this.insertCurrencyItemRequest(this.add_item);
      this.currencyrates.push(result);
      this.add_item = {};
    },
    async addCurrencyChannelRequest() {
      this.isAddChannel = false;
      this.add_channel.currencyid = this.initvalue._id;
      let result = await this.insertCurrencyChannelRequest(this.add_channel);
      this.currencychannels.push(result);
      this.add_channel = {};
    },
    deleteCurrencyListDialog(item) {
      this.isDeleteList = true;
      this.delete_list = { _id: item._id, currencycode: item.currencycode };
    },
    deleteCurrencySubgroupDialog(item) {
      this.isDeleteSubgroup = true;
      this.delete_subgroup = {
        _id: item._id,
        subgroupname: item.subgroupname,
      };
    },
    deleteCurrencyItemDialog(item) {
      this.isDeleteItem = true;
      this.delete_item = {
        _id: item._id,
        itemname: item.itemname,
      };
    },
    async deleteCurrencyList(payload) {
      this.isDeleteList = false;
      let response = await this.deleteCurrencyListRequest(payload);
      let index = this.currencylists.findIndex((trans) => trans._id == response._id);
      this.currencylists.splice(index, 1);
    },
    async deleteCurrencyItem(payload) {
      this.isDeleteItem = false;
      let response = await this.deleteCurrencyItemRequest(payload);
      let index = this.currencyrates.findIndex((trans) => trans._id == response._id);
      this.currencyrates.splice(index, 1);
    },
    async deleteCurrencyChannel(payload) {
      this.isDeleteChannel = false;
      let response = await this.deleteCurrencyChannelRequest(payload);
      let index = this.currencychannels.findIndex((trans) => trans._id == response._id);
      this.currencychannels.splice(index, 1);
    },
    editCurrencyListDialog(item) {
      this.edit_list = Object.assign({}, item);
      this.change_list = {};
      this.isEditList = true;
    },
    editCurrencySubgroupDialog(item) {
      this.edit_subgroup = Object.assign({}, item);
      this.change_subgroup = {};
      this.isEditSubgroup = true;
    },
    editCurrencyItemDialog(item) {
      this.edit_item = Object.assign({}, item);
      this.change_item = {};
      this.isEditItem = true;
    },
    editCurrencyChannelDialog(item) {
      this.edit_channel = Object.assign({}, item);
      this.change_channel = {};
      this.isEditChannel = true;
    },
    async editCurrencyRequest() {
      this.change_currency._id = this.initvalue._id;
      await this.updateCurrencyRequest(this.change_currency);
      router.push('/currency/list');
    },
    async editCurrencyListRequest() {
      this.isEditList = false;
      this.change_list.id = this.edit_list._id;
      let response = await this.updateCurrencyListRequest(this.change_list);
      let index = this.currencylists.findIndex((x) => x._id == response._id);
      this.currencylists.splice(index, 1, response);
      this.edit_list = {};
    },
    async editCurrencyItemRequest() {
      this.isEditItem = false;
      this.change_item.currencyitemid = this.edit_item._id;
      let response = await this.updateCurrencyItemRequest(this.change_item);
      let index = this.currencyrates.findIndex((x) => x._id == response._id);
      this.currencyrates.splice(index, 1, response);
      this.edit_item = {};
    }, 
    async editCurrencyChannelRequest() {
      this.isEditChannel = false;
      this.change_channel.currencyitemid = this.edit_channel._id;
      let response = await this.updateCurrencyChannelRequest(this.change_channel);
      let index = this.currencychannels.findIndex((x) => x._id == response._id);
      this.currencychannels.splice(index, 1, response);
      this.edit_channel = {};
    },    
    onChangeCurrency(value, field){
      this.change_currency[field] = value;
    },
    onChangeList(value, field){
      this.change_list[field] = value;
    },
    onChangeSubgroup(value, field){
      this.change_subgroup[field] = value;
    },
    onChangeItem(value, field){
      this.change_item[field] = value;
    },  
    onChangeChannel(value, field){
      this.change_channel[field] = value;
    },     
  },

  created () {
    this.initvalue = this.$route.params;
    this.currencylists = this.initvalue.lists;
    this.currencyrates = this.initvalue.rates;
    if(!this.initvalue._id) this.$router.push({ name: 'CurrencyList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
